export const ja = {
  ja: {
    translation: {
      confirm_app_exit: 'ベイビーシャークを終了しますか？',
      button_exit: '終了',
      button_cancel: 'キャンセル',
      os_update: '最新TV OSバージョンに更新後、ご利用お願いします。',
      button_ok: '確認',
      t_complete_app_update: 'ベイビーシャークがアップデートされました。',
      error_title: 'エラーが発生しました',
      error_unknown: 'もう一度お試しください。',
      error_network_title: '通信環境が不安定です。',
      error_network: 'ネットワーク接続した後ご利用ください。',
      button_retry: '再試行',
      confirm_continue_watching: '現在視聴中の動画です\n続けてご覧になりますか？',
      button_continue_watching: '続きを見る',
      button_from_beginning: '最初から見る',
      t_event_coming_soon: 'ただいまイベントの準備中です。',
      data_fail: 'エラーが発生しました\nもう一度お試しください。',
      page_sign_in_header: 'QRコードでログインする',
      page_sign_in: 'サービスを利用するにはログインが必要です。\nQRコードを読み取ってログインしてください。',
      page_sign_in_code: '確認コード',
      page_sign_in_time: '残りの時間',
      oauth_confirm_code: 'テレビの確認コードと一致するかご確認お願いします',
      oauth_web_info: 'Webブラウザ',
      oauth_device_info: 'デバイス接続情報',
      oauth_accept_sign_in: 'ログイン承認',
      oauth_sign_in_success: '機器にログインされました',
      oauth_sign_in_cancel: '機器のログインがキャンセルされました',
      oauth_sign_in_fail: 'エラーが発生しました\nQRコードでログインをもう一度お試しください',
      oauth_sign_in_expired:
        'ログインの時間が満了されました\nテレビのQRコードをもう一度読み取って\nログインしてください',
      menu_my: 'マイページ',
      menu_home: 'ホーム',
      menu_story: 'ストーリ',
      menu_song: '子供の歌',
      menu_cinema: '劇場版',
      menu_cinema_and_tv: '劇場版＆テレビシリーズ',
      menu_ip: 'IP',
      menu_topics: 'トピック',
      menu_home_history: '最近見た動画',
      title_ai_videos: 'AI レコメンド ビデオ',
      menu_home_new_content: '新しく登録された動画',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: '利用中の登録券がありません',
      mypage_menu_status_susbcribed: 'Pinfong+に<span class="text-secondary">登録されました。</span>',
      mypage_menu_benefits_unsusbcribed: '登録特典',
      mypage_menu_benefits_susbcribed: '利用特典',
      mypage_menu_benefits_01: '2万余編のオリジナルシリーズ提供',
      mypage_menu_benefits_02: '定期的にアップデートされる\nPinkfong+オリジナルコンテンツ提供',
      mypage_menu_benefits_03: '一度の登録でTV、モバイルの同時利用',
      mypage_menu_benefits_04: '遊びながら学べる30+種のアプリ、無制限利用',
      mypage_scan_to_subscribe: 'QRコードを読み取って登録してください',
      mypage_video_title: 'Pinkfong Plusとは？',
      mypage_menu_terms: '利用規約',
      mypage_menu_event: 'イベント',
      mypage_menu_support: 'お客様センター',
      button_sign_out: 'ログアウト',
      mypage_menu_event_coming_soon: '購読予定の商品',
      mypage_menu_even_open: '進行中',
      terms_required_privacy: 'プライバシーポリシー',
      terms_required_pinkfong: 'サービス利用規約',
      terms_required_interactive: 'Pinkfongインタラクティブアプリの利用規約',
      mypage_menu_device_info: '機器情報',
      page_device_info: '以下の情報を提供していただくと、問題解決をより早くサポートできます。',
      page_device_info_model: 'デバイスモデル',
      page_device_info_os: 'プラットフォームOS',
      page_device_info_version: 'アプリバージョン',
      page_support: 'サービスの利用に関するご質問は、以下のメールアドレスにお問い合わせください。\ncs＠pinkfong.com',
      caution_sign_out: 'ログアウトするとサービスの利用が制限されます。',
      topic_category_all: 'All',
      player_language_button: '言語',
    },
  },
};
